import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { OrphanedTile } from '../../../state-management/models/report-dashboard.model';
import { DashboardContext } from '../../../../../admin/contexts/dashboard.context';
import { map } from 'rxjs/operators';

@Component({
  selector: 'ziro-dashboard-orphaned-devices-tile',
  templateUrl: './dashboard-orphaned-devices-tile.component.html',
  standalone: false,
})
export class DashboardOrphanedDevicesTileComponent implements OnInit {
  private _dashboardContext = inject(DashboardContext);

  orphanedTileData$: Observable<OrphanedTile> = this._dashboardContext.state$.pipe(map((state) => state.orphanedTile));

  ngOnInit(): void {
    this._dashboardContext.loadOrphanedTile();
  }
}
